const titles = {
  home: "Jakub Sokołowski | Personal website",
  projects: "Jakub Sokołowski | Projects"
};

export default titles;
